module.exports = __webpack_public_path__ + "static/media/logo_white.a21289ed.svg";